import { render, staticRenderFns } from "./WarehousingAdd.vue?vue&type=template&id=1f987979&scoped=true"
import script from "./WarehousingAdd.vue?vue&type=script&lang=js"
export * from "./WarehousingAdd.vue?vue&type=script&lang=js"
import style0 from "./WarehousingAdd.vue?vue&type=style&index=0&id=1f987979&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f987979",
  null
  
)

export default component.exports